import { Price } from "../services/searchService";

// Some Price records are generic/wildcard pricing - not tied to a specific
// make/model - stored as vehicle_manufacturer/vehicle_model === "any"
// (see fusion_admindash's PriceForm, which defaults both to "any"). Showing
// that literally ("any any") is meaningless to the customer, so fall back
// to a friendly generic label built from the Plan's vehicle category.
export function getCarDisplayName(price: Price): string {
  const isGeneric =
    price.vehicle_manufacturer?.trim().toLowerCase() === "any" &&
    price.vehicle_model?.trim().toLowerCase() === "any";

  if (isGeneric) {
    const category = price.Plan?.vehicle_category?.[0] ?? "Cab";
    return `Regular ${category}`;
  }

  return `${price.vehicle_manufacturer} ${price.vehicle_model}`;
}

// fuel_type can likewise be the generic "any" - display it as "Any" rather
// than the raw lowercase value.
export function getFuelTypeDisplay(fuelType: string): string {
  if (!fuelType) return "Any";
  return fuelType.trim().toLowerCase() === "any" ? "Any" : fuelType;
}
